// extracted by mini-css-extract-plugin
var _1 = "_inventoryTransactionTable-module__cancel-transaction-button";
var _2 = "_inventoryTransactionTable-module__gold-row";
var _3 = "_inventoryTransactionTable-module__transaction-action-label";
export { _1 as "cancel-transaction-button", _2 as "gold-row", _3 as "transaction-action-label" }
